








import { Component, Prop, Vue } from 'vue-property-decorator';
import AdoptCenter from '@/components/AdoptCenter.vue';

@Component({
  components: {
    AdoptCenter,
  },
})
export default class Exchange extends Vue {
  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }
}
